export { Text } from '$views/components/Text/Text'



// WEBPACK FOOTER //
// ./src/views/components/Text/index.tsx